<script setup lang="ts">
import { money } from '@nuts/auto-delivery-sdk/dist/utils/format';
import { computed } from 'vue';

import InformationBanner from '@/components/base/layout/InformationBanner.vue';
import BaseBodyText from '@/components/base/typography/BaseBodyText.vue';
import SmallBodyText from '@/components/base/typography/SmallBodyText.vue';
import { Channel } from '@/stores/autoDelivery';
import { Money } from '@/utils/money';
import { getPrice, NutsProductVariant } from '@/utils/product';

const props = defineProps<{
  channel: Channel;
  variant: NutsProductVariant;
}>();

const listPrice = computed(() => getPrice(props.variant));
const channelPrice = computed(() => getPrice(props.variant, props.channel.key));
const selectedPrice = computed(
  () => (!props.variant.wholesale && channelPrice.value) || listPrice.value,
);
const hasDiscount = computed(() => !Money.equals(selectedPrice.value.value, listPrice.value.value));
</script>

<template>
  <div v-if="listPrice.discounted">
    <InformationBanner class="p-4" variant="info">
      <BaseBodyText
        class="font-semibold text-nuts-cyan-800"
        data-test="auto-delivery-discount-message"
      >
        The discounted price does not qualify for Auto-Delivery subscription<template
          v-if="!variant.wholesale"
          >, but you can still enjoy {{ channel.discount }}% off of the listing price</template
        >.
      </BaseBodyText>
    </InformationBanner>
    <div class="flex mt-4 md:mt-6 gap-x-2">
      <SmallBodyText class="font-semibold">Price</SmallBodyText>
      <SmallBodyText class="ml-auto font-semibold">
        <span v-if="hasDiscount" class="sr-only">Discounted price of</span>
        {{ money(selectedPrice.value) }}
      </SmallBodyText>
      <SmallBodyText v-if="hasDiscount" class="line-through text-neutral-600">
        <span class="sr-only">Original price was</span>
        {{ money(listPrice.value) }}
      </SmallBodyText>
    </div>
  </div>
</template>
